<div class="container-fluid certification-card flex-grow-1">
  <div class="row">
    <div class="col-auto">
      <img src="{{certification?.logoUrl}}" alt="">
    </div>
    <div class="col">
      <div class="row">
        <div class="col-12 title">
          {{certification?.code}}
        </div>
      </div>
      <div class="row">
        <div class="col-12 subtitle">
          {{certification?.name}}
        </div>
      </div>
      <div class="row">
        <div class="col-12 description">
          {{certification?.description}}
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <mat-divider style="margin-top: 20px;"></mat-divider>
    </div>
    <div class="col-12 btn-container">
      <button mat-flat-button (click)="handleBegin()" [disabled]="!certification?.canAccess">
        <ng-container *ngIf="certification.cityCertification">
          <span [translate]="'city-profile-certification/continue'">Continuar</span>
        </ng-container>
        <ng-container *ngIf="!certification.cityCertification">
          <span [translate]="'city-profile-certification/start'">INICIAR</span>
        </ng-container>
      </button>
    </div>
    <div class="col-12">
      <mat-divider></mat-divider>
    </div>
  </div>
</div>